import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Layout, Menu, Button, Drawer, Popover } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import styles from "./index.scss";

import routePaths from "app/components/Router/routePaths";

import ProfileMenu from "shared/ProfileMenu";
import PrimaryLogo from "shared/PrimaryLogo";
import { isAllowed } from "shared/Auth";
import useTenantHook from "hooks/useTenantHook";
import { TENANT_CODES } from "utils/tenants";
import { redirect } from "../../../actions/navigation";
import { useDispatch } from "react-redux";
const { SubMenu } = Menu;
const { Header } = Layout;

const primaryNavs = [
  {
    name: "Dashboard",
    key: "home",
    icon: "",
    path: routePaths.homePage,
  },
  {
    name: "Quotation",
    key: "quotation",
    icon: "",
    path: routePaths.quotation,
    // Quotations launch for the KH tenant only (Quotation_Tech_Design §7).
    tenantRestriction: TENANT_CODES.KH,
  },
  {
    name: "Purchase Orders",
    key: "purchase-order",
    icon: "",
    path: routePaths.purchaseOrder,
    // B2B purchase orders launch for the KH tenant only (PO PRD §1).
    tenantRestriction: TENANT_CODES.KH,
  },
  {
    name: "Offline Payments",
    key: "offline",
    icon: "",
    path: routePaths.offlinePayments,
    // subMenu: pageNavs,
  },
  {
    name: "Refunds",
    key: "refunds",
    icon: "",
    path: routePaths.refunds,
    // subMenu: pageNavs,
  },
  {
    name: "Transfers",
    key: "transfers",
    icon: "",
    path: routePaths.transfers,
    // subMenu: pageNavs,
  },
  {
    name: "Deferrals",
    key: "deferrals",
    icon: "",
    path: routePaths.deferrals,
    // subMenu: pageNavs,
  },
  {
    name: "Coupons",
    key: "coupons",
    icon: "",
    path: routePaths.coupons,
    // subMenu: pageNavs,
  },
  {
    name: "User Info",
    key: "user-info",
    icon: "",
    path: routePaths.userInfo,
    // subMenu: pageNavs,
  },
  {
    name: "Applications",
    key: "applications",
    icon: "",
    path: routePaths.applications,
    // subMenu: pageNavs,
  },
  {
    name: "Franchise",
    key: "franchise",
    icon: "",
    path: routePaths.franchise,
    // subMenu: pageNavs,
  },
  {
    name: "Document",
    key: "document",
    icon: "",
    path: routePaths.document,
  },
  {
    name: "Subscriptions",
    key: "subscriptions",
    icon: "",
    path: routePaths.subscriptions,
  },
  {
    name: "Stores",
    key: "stores",
    icon: "",
    path: routePaths.stores,
    tenantRestriction: "LC",
  },
  /* {
		name: "Content",
		key: "content",
		icon: "",
		path: routePaths.pageListerPage,
		subMenu: pageNavs,
	},
	{
		name: "Entities",
		key: "entities",
		icon: "",
		path: routePaths.entities__overview,
		subMenu: entitiesNavs,
	},
	{
		name: "Users",
		key: "users",
		icon: "",
		path: routePaths.roleManagement__overview,
		subMenu: userNavs,
	},
	{
		name: "Program Launcher",
		key: "program-launcher",
		icon: <ThunderboltFilled />,
		path: routePaths.programLaunchManagement,
		feature: features.ROLE_CONFIG,
	}, */
];

const PrimaryHeader = ({ location, isMobile }) => {
  const [mobileMenuIconOpen, setMobileMenuIcon] = useState(false);
  const [showDesktopSubMenu, setShowDesktopSubMenu] = useState(null);
  const { currentTenant, currentTenantCode } = useTenantHook();
  const dispatch = useDispatch();

  const filteredNavs = primaryNavs.filter(
    (nav) => !nav.tenantRestriction || nav.tenantRestriction === currentTenantCode
  );

  const toggleMobileMenu = () => {
    setMobileMenuIcon(!mobileMenuIconOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuIcon(false);
  };

  const isMenuHighlighted = () => {
    const locationKey = location.pathname.split("/")[1];
    return locationKey == "" ? "home" : locationKey;
  };

  const buildMobilePrimaryMenuItem = (menuItem) => {
    return (
      <Menu.Item theme="light" key={menuItem.key} icon={menuItem.icon}>
        <NavLink
          className="ant-dropdown-navlink"
          to={menuItem.path}
          onClick={closeMobileMenu}
        >
          {menuItem.name}
        </NavLink>
      </Menu.Item>
    );
  };

  const buildDesktopSubMenu = (menuItem, subMenu) => {
    return (
      <div
        key={menuItem.key}
        title={menuItem.name}
        className={styles.desktopSubMenuWrapper}
      >
        {subMenu.map((subMenuNav) => {
          return (
            <div
              key={subMenuNav.key}
              className={styles.item}
              disabled={subMenuNav.feature && !isAllowed(subMenuNav.feature)}
              style={{ textAlign: "left" }}
            >
              <NavLink
                to={subMenuNav.path}
                onClick={() => setShowDesktopSubMenu("")}
              >
                <div className={styles.info}>
                  <div className={styles.img}>
                    <img src={subMenuNav.svgIcon} />
                  </div>
                  <div className={styles.detail}>
                    <div className={styles.title}>{subMenuNav.name}</div>
                    <div className={styles.desc}>{subMenuNav.description}</div>
                  </div>
                </div>
              </NavLink>
            </div>
          );
        })}
      </div>
    );
  };

  const buildDesktopPrimaryMenuItem = (menuItem, subMenu) => {
    const highlightedMenuKey = location.pathname.split("/")[1];
    return (
      <Menu.Item theme="light" key={menuItem.key} icon={menuItem.icon}>
        {subMenu ? (
          <Popover
            content={buildDesktopSubMenu(menuItem, subMenu)}
            trigger="click"
            visible={showDesktopSubMenu == menuItem.key}
            onMouseEnter={() => setShowDesktopSubMenu(menuItem.key)}
            placement="bottom"
            overlayStyle={{
              position: "fixed",
              borderRadius: "6px",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.15)",
            }}
          >
            <NavLink
              to={menuItem.path}
              className={cx(styles.desktopSubMenuItem, {
                [styles.isActive]: menuItem.key == highlightedMenuKey,
              })}
            >
              {menuItem.name}
            </NavLink>
          </Popover>
        ) : (
          <NavLink
            to={menuItem.path}
            onMouseEnter={() => setShowDesktopSubMenu("")}
          >
            {menuItem.name}
          </NavLink>
        )}
      </Menu.Item>
    );
  };

  const buildMobileSubMenu = (menuItem, subMenu) => {
    return (
      <SubMenu
        key={menuItem.key}
        title={menuItem.name}
        icon={menuItem.icon}
        triggerSubMenuAction="hover"
        forceSubMenuRender
        style={{ textAlign: "left" }}
        popupClassName={styles.subMenuPopup}
      >
        {subMenu.map((subMenuNav) => {
          return (
            <Menu.Item
              key={subMenuNav.key}
              disabled={subMenuNav.feature && !isAllowed(subMenuNav.feature)}
              style={{ textAlign: "left" }}
            >
              <NavLink to={subMenuNav.path} onClick={closeMobileMenu}>
                {subMenuNav.name}
              </NavLink>
            </Menu.Item>
          );
        })}
      </SubMenu>
    );
  };

  return (
    <Header className={cx(styles.root, { [styles.isMobile]: isMobile })}>
      {isMobile && (
        <>
          <Button
            type="text"
            onClick={toggleMobileMenu}
            className={styles.toggleBtn}
          >
            <MenuOutlined style={{ color: "#FFF", fontSize: "20px" }} />
          </Button>
          <Drawer
            title="✋Navigation"
            placement="right"
            closable={true}
            onClose={toggleMobileMenu}
            visible={mobileMenuIconOpen}
            headerStyle={{ background: "#fbfbfb" }}
            bodyStyle={{
              padding: 0,
              justifyContent: "flex-start",
              display: "flex",
              flexDirection: "column",
            }}
            key="left"
          >
            <ProfileMenu isMobile={isMobile} />
            <Menu
              selectedKeys={isMenuHighlighted()}
              mode="inline"
              style={{ textAlign: "left" }}
            >
              {filteredNavs.map((menuItem) =>
                menuItem.subMenu
                  ? buildMobileSubMenu(menuItem, menuItem.subMenu)
                  : buildMobilePrimaryMenuItem(menuItem)
              )}
            </Menu>
          </Drawer>
        </>
      )}

      <div className={styles.logoWrapper}>
        <PrimaryLogo />
        {currentTenant && (
          <div className={styles.tenant}>
            <Button
              type="button"
              onClick={() => {
                dispatch(redirect("/"));
              }}
            >
              Tenant: &nbsp;{" "}
              <span className={styles.tenantName}>{currentTenant.name}</span>
            </Button>
          </div>
        )}
      </div>
      {!isMobile && (
        <>
          <Menu
            selectedKeys={isMenuHighlighted()}
            theme="dark"
            className={styles.primaryMenuWrapper}
            mode="horizontal"
            onMouseLeave={() => setShowDesktopSubMenu("")}
          >
            {filteredNavs.map((menuItem) =>
              buildDesktopPrimaryMenuItem(menuItem, menuItem.subMenu)
            )}
          </Menu>
          <ProfileMenu />
        </>
      )}
    </Header>
  );
};

PrimaryHeader.propTypes = {
  location: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
};

export default PrimaryHeader;
